import { EventEmitter } from '@angular/core';
var StorageService = /** @class */ (function () {
    function StorageService(storage) {
        this.storage = storage;
        this._changeEmitter = new EventEmitter();
    }
    Object.defineProperty(StorageService.prototype, "changeKey", {
        get: function () {
            return this._changeEmitter;
        },
        enumerable: true,
        configurable: true
    });
    StorageService.prototype.clear = function () {
        if (typeof this.storage.clear === 'function') {
            this.storage.clear();
        }
        else {
            this.storage = {};
        }
    };
    StorageService.prototype.get = function (key) {
        return this.storage[key];
    };
    StorageService.prototype.getJson = function (key) {
        try {
            return JSON.parse(this.get(key));
        }
        catch (e) {
        }
    };
    StorageService.prototype.set = function (key, value) {
        this.storage[key] = value;
        this._changeEmitter.emit({ key: key, value: value });
    };
    StorageService.prototype.setJson = function (key, value) {
        this.set(key, JSON.stringify(value));
    };
    StorageService.prototype.remove = function (key) {
        delete this.storage[key];
        this._changeEmitter.emit({ key: key });
    };
    return StorageService;
}());
export { StorageService };
